module.exports = __webpack_public_path__ + "img/slotmachine.38559df8.png";